import FaqAccordion from './FaqAccordion';
const VARIANTS = { 'faq-accordion': FaqAccordion };
export default function FaqSection({ section, data, theme, settings }) {
  const Variant = VARIANTS[section.variant] || FaqAccordion;
  return <Variant section={section} data={data} theme={theme} settings={settings} />;
}
